import React from "react";
import Hero from "./Hero/Hero";
import Footer from "../../components/Footer/Footer";

const Home = () => {
  return <div>
    <Hero/>
    <Footer/>
  </div>;
};

export default Home;
